module.exports = __webpack_public_path__ + "img/whiteLogo.807ac84e.png";